import type { ContactSummaryDto } from '../../../api';
import type { ProjectCreateDto } from '../../../api';
import type { ScaffoldingStepFields } from '../../../validations/scaffoldingStepValidation';

export type CreateProjectFields = ScaffoldingStepFields & {
  projectNumber: string;
  department?: number;
  projectName: string;
  projectAddress: string;
  customerId?: number;
  teamLeaderId?: number;
  contacts?: ContactSummaryDto[];
  dateOfConstructionStart?: string;
  dateOfConstructionEnd?: string;
  hasMonteringsanalys: boolean;
  erpProjectRef?: string | null;
};

export const toProjectCreateDto = (
  fields: CreateProjectFields,
): ProjectCreateDto => ({
  projectNumber: fields.projectNumber,
  department: fields.department,
  projectName: fields.projectName,
  projectAddress: fields.projectAddress,
  customerId: fields.customerId,
  teamLeaderId: fields.teamLeaderId,
  contacts: fields.contacts,
  dateOfConstructionStart: fields.dateOfConstructionStart,
  dateOfConstructionEnd: fields.dateOfConstructionEnd,
  squareMeters: fields.squareMeters,
  accessRoutes: fields.accessRoutes,
  scaffoldingType: fields.scaffoldingType,
  scaffoldingIntendedFor: fields.scaffoldingIntendedFor,
  scaffoldingWidth: fields.scaffoldingWidth,
  scaffoldingHeight: fields.scaffoldingHeight,
  hasMonteringsanalys: fields.hasMonteringsanalys,
  erpProjectRef: fields.erpProjectRef,
});
